<ng-container *ngIf="sectionConfiguration?.list?.priorityAvailable && (isEditable || (previousReviews$ | async).length > 0)">

<section class="selection-wrapper">
    <section class="reviewers-section" *ngIf="previousReviews$|async as previousReviews">
      <i class="reviewers-navigation previous fa fa-chevron-left"
         *ngIf="currentIndex !== 0 && amountOfReviews > 2"
         (click)="navigateTo(-3)"
      ></i>
      <section class="reviewers">
        <ng-container *ngFor="let review of previousReviews;trackBy:trackByFn(review);let i = index">
          <ng-container
            *ngTemplateOutlet="ReviewerAvatar;context:{review:review,countText:getCountText(i+1),userType:userType,reviewToSet:review}"
          ></ng-container>
        </ng-container>
        <ng-container *ngIf="isEditable">
          <ng-container
            *ngTemplateOutlet="ReviewerAvatar;context:{review:{practitionerId:currentUserId$|async},countText:getCountText(amountOfReviews+1),userType:userType,reviewToSet:null}"
          ></ng-container>
        </ng-container>
      </section>
      <i class="reviewers-navigation next fa fa-chevron-right"
         *ngIf="amountOfReviews > 2 && currentIndex !== amountOfReviews"
         (click)="navigateTo(3)"
      ></i>
    </section>

  <section class="displayed-review">
    <gen-therapies-selection
      [revisionId]="revisionId"
      [workflowId]="workflowId"
      [showPractitionerLayout]="false"
      [edit]="!activeReview"
      [review]="activeReview"
      [displayActionButtons]="isEditable"
      [signoffAllowed]="signOffAvailable"
      [fields]="sectionConfiguration?.list?.fields"
      [pathToList]="sectionConfiguration?.list?.pathToList"
      [priorityAvailable]="sectionConfiguration?.list?.priorityAvailable"
      [allowManual]="sectionConfiguration?.list?.allowManual"
      [allowTherapyFreeText]="sectionConfiguration?.list?.allowTherapyFreeText"
      [targetMaxLength]="sectionConfiguration?.list?.targetMaxLength"
      [textPath]="sectionConfiguration?.textPath"
      [textEditable]="sectionConfiguration?.textEditable"
      [EnableAddingTrials]="sectionConfiguration?.EnableAddingTrials"
      (inprogressUpdate)="emitInprogressUpdate($event)"
    ></gen-therapies-selection>
  </section>

</section>


<ng-template #ReviewerAvatar
             let-review="review"
             let-reviewToSet="reviewToSet"
             let-countText="countText"
             let-userType="userType">
  <div class="single-reviewer" [ngClass]="{'active-reviewer':reviewsAreEqual(reviewToSet)}"
       (click)="setActiveReview(reviewToSet)">
    <gen-user-profile
      [userType]="userType"
      [id]="review.practitionerId"
      [layout]="'PIC_ONLY'"
    ></gen-user-profile>
    <span class="counter-text">{{countText}} <span *ngIf="review?.meta?.created">({{review?.meta?.created | date: 'dd MMM y'}})</span></span>
    <gen-user-profile
      class="reviewer-name"
      [userType]="userType"
      [id]="review.practitionerId"
      [showPrefix]="true"
      [layout]="'NAME_ONLY'"
    ></gen-user-profile>
  </div>
</ng-template>

</ng-container>
